/* eslint-disable-next-line no-restricted-imports */
import type { DeliveryValidation, Store } from '@jane/shared/models';

export function minimumDeliveryOrder({
  discountedSubtotal,
  store,
  deliveryValidateData,
}: {
  deliveryValidateData?: DeliveryValidation;
  discountedSubtotal: number;
  store: Store;
}) {
  if (!store.delivery) return true;
  else if (deliveryValidateData)
    return discountedSubtotal >= (deliveryValidateData?.minimum || 0);
  else return true;
}
